import { FC } from "react";
import { useChatStore } from "../../stores/ChatStore";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useIntl } from "react-intl";
interface Props {
    setOpenDetailContact: (value: boolean) => void
}

const ChatGroupWindowTitle: FC<Props> = ({ setOpenDetailContact }) => {
    const intl = useIntl()
    const { groupID, listChatGroupRooms, selectedChatPhone } = useChatStore()
    const dataChatRoom = listChatGroupRooms[groupID]
    let name = dataChatRoom?.groupName

    return (
        <div className='card-title m-0'>
            <div className='d-flex justify-content-center flex-column'>
                <div className="d-flex gap-2 align-items-center mb-2">
                    {
                        dataChatRoom && selectedChatPhone.length > 1 &&
                        <OverlayTrigger
                            key={`bullet-${dataChatRoom.chat.id}`}
                            placement='bottom'
                            overlay={
                                <Tooltip id='tooltip-labels'>
                                    <span><b>{dataChatRoom.as}</b></span><br />
                                    <span>{selectedChatPhone.find(item => item.phone === dataChatRoom.as)?.ownersName.join(', ')}</span>
                                </Tooltip>}
                        >
                            <div className="d-flex align-items-center">
                                <span className="bullet bullet-dot h-10px w-10px" style={{ backgroundColor: dataChatRoom.color }}></span>
                            </div>
                        </OverlayTrigger>
                    }

                    {
                        <span className='fs-4 fw-bolder text-gray-900 lh-1 text-hover-primary cursor-pointer' onClick={() => setOpenDetailContact(true)}>
                            {name}
                        </span>
                    }
                </div>
                {
                    dataChatRoom?.participants.length > 0 &&
                    <i>{dataChatRoom.participants.length} {intl.formatMessage({ id: "FORM.LABEL.MEMBER" })}</i>
                }
            </div>
        </div>
    )
}

export { ChatGroupWindowTitle }